var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('Navigation'),_c('main',{class:_vm.$style.body},[_c('div',{class:_vm.$style.page},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }